import { Category } from "../types";

/**
 * Превращает дерево категорий (со вложенными children) в единый плоский массив,
 * сохранив все категории. Удобно для быстрого поиска "по id".
 */
export function flattenCategories(categories: Category[]): Category[] {
  const result: Category[] = [];

  function dfs(catList: Category[]) {
    for (const cat of catList) {
      result.push(cat);
      if (cat.children?.length) {
        dfs(cat.children);
      }
    }
  }

  dfs(categories);
  return result;
}

/**
 * Находит путь (цепочку) от корня до категории `categoryId`.
 * Например, если структура:
 *   - Тело (id=2)
 *     - Автозагары (id=7)
 *   то для categoryId=7 функция вернёт [ {id:2, ...}, {id:7, ...} ].
 */
export function getCategoryChain(allCategories: Category[], categoryId: number): Category[] {
  // 1. Получаем плоский список, чтобы легче искать категории по id
  const flat = flattenCategories(allCategories);

  // 2. Создаём map: id -> категория
  const catMap: Record<number, Category> = {};
  for (const cat of flat) {
    catMap[cat.id] = cat;
  }

  // 3. Строим цепочку, идя от потомка к родителю (parent_id)
  const chain: Category[] = [];
  let current = catMap[categoryId];

  while (current) {
    chain.unshift(current); // вставляем в начало
    if (!current.parent_id) break; // дошли до корневой (parent_id=null)
    current = catMap[current.parent_id];
  }

  return chain;
}



export function findCategoryById(categories: Category[], id: number): Category | undefined {
  for (const cat of categories) {
    if (cat.id === id) {
      return cat;
    }
    // Если есть дочерние, идём вглубь
    if (cat.children && cat.children.length > 0) {
      const result = findCategoryById(cat.children, id);
      if (result) {
        return result;
      }
    }
  }
  return undefined;
}